import { NavLink } from 'react-router-dom';
import { ClipboardList, PackageSearch, Boxes, History, Repeat } from 'lucide-react';
import { useTenant, useIsSuperAdmin } from '@paulownia/shared/lib/tenant-context';

export function TabNav() {
  const { claims } = useTenant();
  const isSuperAdmin = useIsSuperAdmin();
  const base = 'flex flex-col items-center justify-center gap-1 text-xs';
  const active = 'text-orange-600';
  const inactive = 'text-gray-500';

  // Hide TabNav if user has no tenants (unless superadmin)
  if (!isSuperAdmin && (!claims?.tenantIds || claims.tenantIds.length === 0)) {
    return null;
  }

  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 border-t bg-white">
      <div className="grid grid-cols-5 h-14">
        <NavLink to="/dashboard" className={({ isActive }) => `flex items-center justify-center ${isActive ? active : inactive}`}>
          <div className={base}>
            <ClipboardList className="h-5 w-5" />
            <span>Commandes</span>
          </div>
        </NavLink>
        <NavLink to="/products/status" className={({ isActive }) => `flex items-center justify-center ${isActive ? active : inactive}`}>
          <div className={base}>
            <PackageSearch className="h-5 w-5" />
            <span>Statut</span>
          </div>
        </NavLink>
        <NavLink to="/products/manage" className={({ isActive }) => `flex items-center justify-center ${isActive ? active : inactive}`}>
          <div className={base}>
            <Boxes className="h-5 w-5" />
            <span>Produits</span>
          </div>
        </NavLink>
        <NavLink to="/recurring" className={({ isActive }) => `flex items-center justify-center ${isActive ? active : inactive}`}>
          <div className={base}>
            <Repeat className="h-5 w-5" />
            <span>Récurrents</span>
          </div>
        </NavLink>
        <NavLink to="/history" className={({ isActive }) => `flex items-center justify-center ${isActive ? active : inactive}`}>
          <div className={base}>
            <History className="h-5 w-5" />
            <span>Historique</span>
          </div>
        </NavLink>
      </div>
    </nav>
  );
}



